export default "__VITE_ASSET__f0522a65__"